import { Link } from "react-router-dom";
import PublicFooter from "@/components/PublicFooter";

const LOGO = "/brand/mtg_logo.svg";

function Section({ title, children }) {
  return (
    <section className="mt-8">
      <h2 className="font-display text-xl font-bold text-[#16324F]">{title}</h2>
      <div className="mt-2 text-sm text-slate-600 leading-relaxed space-y-1.5">{children}</div>
    </section>
  );
}

export default function MentionsLegales() {
  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid="page-mentions-legales">
      <div className="px-6 md:px-12 py-6 max-w-3xl mx-auto w-full">
        <Link to="/" className="inline-flex items-center gap-2" data-testid="legal-home-link">
          <img src={LOGO} alt="MonTempsGagné" className="h-9" />
        </Link>
        <Link to="/" className="mt-6 inline-block text-sm text-slate-500 hover:text-[#16324F]">← Retour à l'accueil</Link>

        <h1 className="mt-4 font-display text-3xl md:text-4xl font-extrabold text-[#16324F] tracking-tight">Mentions légales</h1>
        <p className="mt-3 text-sm text-slate-500">
          Informations relatives à l'éditeur et à l'hébergement du service MonTempsGagné (montempsgagne.fr).
        </p>

        <Section title="Éditeur du site">
          <p>Le service MonTempsGagné est édité par <strong>Kevin Fernandez</strong>, exerçant sous le nom commercial <strong>FlamingOps</strong>.</p>
          <p>Statut : entrepreneur individuel (micro-entrepreneur).</p>
          <p>SIRET : 818 072 761 00039 — Code APE : 6201Z.</p>
          <p>Adresse : 721 Rue du Pré aux Clercs, 34090 Montpellier, France.</p>
          <p>E-mail : <a href="mailto:fernandez@flamingops.fr" className="text-[#19C3B3] underline underline-offset-2">fernandez@flamingops.fr</a> — Téléphone : 07 52 82 04 95.</p>
          <p>Directeur de la publication : Kevin Fernandez.</p>
        </Section>

        <Section title="Hébergement">
          <p>
            L'application MonTempsGagné est déployée et hébergée via la plateforme <strong>Emergent</strong>,
            exploitée par <strong>Agione Technologies Private Limited</strong> — B-1103, Salarpuria Sattva
            Magnificia, Tin Factory, Krishnarajapuram R.S., Bangalore, KA 560016, Inde.
          </p>
          <p>
            L'infrastructure technique repose sur des sous-traitants d'hébergement d'Emergent. La liste et la
            localisation applicable sont indiquées dans la politique de confidentialité et sur la page des
            sous-traitants d'Emergent :{" "}
            <a href="https://app.emergent.sh/subprocessors" target="_blank" rel="noopener noreferrer" className="text-[#19C3B3] underline underline-offset-2">app.emergent.sh/subprocessors</a>.
          </p>
          <p className="text-slate-500">Le nom de domaine montempsgagne.fr est géré via OVH (bureau d'enregistrement), qui n'est pas l'hébergeur de l'application.</p>
        </Section>

        <Section title="Propriété intellectuelle">
          <p>
            L'ensemble des contenus de ce site (textes, visuels, logo, éléments graphiques) sont la propriété
            de Kevin Fernandez / FlamingOps, sauf mention contraire. Toute reproduction ou réutilisation, totale
            ou partielle, est interdite sans autorisation écrite préalable.
          </p>
        </Section>

        <Section title="Responsabilité">
          <p>
            FlamingOps s'efforce de maintenir les informations de ce site à jour, sans garantir leur exactitude,
            leur complétude ou leur actualité. Les informations affichées le sont à titre indicatif et ne
            constituent pas un engagement contractuel tant qu'un devis n'a pas été validé.
          </p>
        </Section>

        <Section title="Liens hypertextes">
          <p>
            Ce site peut contenir des liens vers des sites tiers. FlamingOps n'est pas responsable de leur contenu,
            de leur fonctionnement ni de leur politique de confidentialité.
          </p>
        </Section>

        <Section title="Données personnelles">
          <p>
            Le traitement des données personnelles est décrit dans notre{" "}
            <Link to="/confidentialite" className="text-[#19C3B3] underline underline-offset-2">politique de confidentialité</Link>.
          </p>
        </Section>

        <Section title="Contact">
          <p>Pour toute question : <a href="mailto:fernandez@flamingops.fr" className="text-[#19C3B3] underline underline-offset-2">fernandez@flamingops.fr</a>.</p>
        </Section>
      </div>
      <div className="mt-12"><PublicFooter /></div>
    </div>
  );
}
